import { __decorate } from "tslib";
import { __metadata } from "tslib";
import { Component, Input } from '@angular/core';
var LabelComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function LabelComponent() {
        this.bold = false;
        /**
         * Set our default values
         */
        this.localState = { value: '' };
    }
    LabelComponent.prototype.ngOnInit = function () {
    };
    LabelComponent.prototype.submitState = function (value) {
    };
    return LabelComponent;
}());
export { LabelComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/label/label.component.ts
// module id = null
// module chunks = 